window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header')
	const hamburger = document.querySelector('header .hamburger')
	let previousScrollTop = 0

	window.addEventListener('scroll', e => {
		let currentScrollTop = window.scrollY

		if (previousScrollTop - currentScrollTop < 0 && currentScrollTop > 150) {
			header.classList.add('scrolled-down')
			hamburger.classList.remove('open')
		} else {
			header.classList.remove('scrolled-down')
		}

		previousScrollTop = currentScrollTop
	})

	hamburger.addEventListener('click', e => {
		hamburger.classList.toggle('open')
	})

	window.addEventListener('click', e => {
		if (e.target.tagName != 'A' && !e.target.closest('.hamburger')) {
			hamburger.classList.remove('open')
		}
	})
})
